var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.28613 11H9.88613V12.6667H8.28613V11ZM8.28613 14.3333H9.88613V16H8.28613V14.3333ZM11.4861 11H13.0861V12.6667H11.4861V11ZM11.4861 14.3333H13.0861V16H11.4861V14.3333ZM14.6861 11H16.2861V12.6667H14.6861V11ZM14.6861 14.3333H16.2861V16H14.6861V14.3333Z","fill":"#00A9E0","key":0}),React.createElement("path",{"d":"M6.84169 20H17.7306C18.5885 20 19.2861 19.2824 19.2861 18.4V7.2C19.2861 6.3176 18.5885 5.6 17.7306 5.6H16.175V4H14.6195V5.6H9.9528V4H8.39724V5.6H6.84169C5.9838 5.6 5.28613 6.3176 5.28613 7.2V18.4C5.28613 19.2824 5.9838 20 6.84169 20ZM17.7306 7.2L17.7314 18.4H6.84169V7.2H17.7306Z","fill":"#00A9E0","key":1})]);
}

Calendar.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
